{
  "campaignName": "infiniFi Points",
  "platform": "infiniFi",
  "description": "Points for providing liquidity.",
  "platformImageId": "infinifi.png",
  "dashboardLink": "https://app.infinifi.xyz/points/",
  "pools": [
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x2E2d6C119bdF226C420cB40E3B9fC9689cF5986e",
      "network": "ethereum",
      "multiplier": "4.5x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x3e823bd1015ba1a12f2f8afd631c822a1cba0de7",
      "network": "ethereum",
      "multiplier": "4.5x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x46f27bd3ec8f8d602f7ce85d312f4387fbda7b16",
      "network": "ethereum",
      "multiplier": "2.5x",
      "tags": ["points"],
      "lock": "false"
    }
  ]
}
